import { GlTable } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import EmptyResult from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/empty_result.vue?vue3';
import ProjectCell from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/admin/jobs_table/components/cells/project_cell.vue?vue3';
import RunnerCell from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/admin/jobs_table/components/cells/runner_cell.vue?vue3';
import { JOBS_DEFAULT_FIELDS } from '../constants';
import ActionsCell from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/jobs_page/components/job_cells/actions_cell.vue?vue3';
import StatusCell from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/jobs_page/components/job_cells/status_cell.vue?vue3';
import JobCell from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/jobs_page/components/job_cells/job_cell.vue?vue3';
import PipelineCell from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/jobs_page/components/job_cells/pipeline_cell.vue?vue3';
export default {
    name: 'JobsTable',
    components: {
        ActionsCell,
        StatusCell,
        JobCell,
        PipelineCell,
        ProjectCell,
        RunnerCell,
        GlTable,
        EmptyResult
    },
    props: {
        jobs: {
            type: Array,
            required: true
        },
        tableFields: {
            type: Array,
            required: false,
            default: ()=>JOBS_DEFAULT_FIELDS
        },
        admin: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        showCoverage (coverage) {
            return coverage || coverage === 0;
        },
        formatCoverage (coverage) {
            return `${coverage}%`;
        }
    }
};
